import axios from 'axios'
import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify';
import { Cartcontext } from '../Cartcontext';
import { WishlistContext } from '../WishContext';


function Product({ product }) {
    const {cart ,setcart} = useContext(Cartcontext)
    const { addToWishlist, removeFromWishlist ,isInWishlist } = useContext(WishlistContext );
    async function addProductToCart(Product_id) {
        const { data } = await axios.post('https://ecommerce.routemisr.com/api/v1/cart?', { productId: Product_id }, {
            headers: { token: localStorage.getItem('token') }
        })
        toast.success("successfuly added ⭐ ​", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
        setcart(data)
        console.log(data)
    }
    
    async function addProductToWish(Product_id) {
        const { data } = await axios.post('https://ecommerce.routemisr.com/api/v1/wishlist?', { productId: Product_id }, {
            headers: { token: localStorage.getItem('token') }
        })
        toast("successfuly added to wish list ❤️​", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",

        });
        console.log(data)
    }
    async function RemoveProductWish(productId) {
        await axios.delete('https://ecommerce.routemisr.com/api/v1/wishlist/' + productId, { headers: { token: localStorage.getItem('token') } })
  }

    return (
        <div className="product overflow-hidden px-2 py-3 cursor-pointer">
            <Link to={'/productdetails/' + product.id} className='a'>
                <img className='w-100' src={product.imageCover} alt="" />
                <h5 className='font-sm text-main'>{product.category.name}</h5>
                <h4>{product.title.split(" ").slice(0, 2).join(" ")}</h4>

                <p className='d-flex justify-content-between'>
                    <span >{product?.price} EGP</span>
                    <span>
                        <i className='fas fa-star rating-color me-1'></i>
                        {product?.ratingsAverage}
                    </span>
                </p>
            </Link>
            <i
        onClick={() => {
          if (isInWishlist(product.id)) {
            RemoveProductWish(product.id);
            removeFromWishlist(product.id)
          } else {
            addProductToWish(product.id);
            addToWishlist(product)
          }
        }}
        className={`fa-solid fa-heart h3 ${
          isInWishlist(product.id) ? 'text-danger' : ''
        }`}
      ></i>
            <button onClick={() => {
                addProductToCart(product.id)
            }} className='btn bg-main text-white w-100 '>+Add To Cart</button>
        </div>
    )
}

export default Product